function sectionsInit() {
  let wrapper = document.querySelector('.wrapper');
  let windowWidth = document.documentElement.clientWidth;

  let employeesSection = document.querySelector('.employees');
  let employeesSectionOffsetLeft = employeesSection.getBoundingClientRect().left;
  let employeesSectionWidth = employeesSection.clientWidth;
  let employeesSectionLine = document.querySelector('.employees .line');
  let employeesSectionOffsetTop = employeesSection.getBoundingClientRect().top;
  let employeesSectionWrapper = document.querySelector('.employees__wrapper');
  let employeesSectionList = document.querySelector('.employees__list');
  let employeesSectionListItems = document.querySelectorAll('.employees__item');
  let employeesSectionMore = document.querySelector('.employees__more');

  let ecologySection = document.querySelector('.ecology');
  let ecologySectionContainer = document.querySelector('.ecology .container');
  let ecologySectionWidth = ecologySection.clientWidth;
  let ecologySectionGradient = document.querySelector('.ecology .section__gradient');
  let ecologySectionLine = document.querySelector('.ecology .line');
  let ecologySectionIcons = document.querySelectorAll('.ecology .section__icon');
  let ecologySectionList = document.querySelector('.ecology .section__slides');
  let ecologySectionListOffsetTop = ecologySectionList.getBoundingClientRect().top;
  let ecologySectionListHeight = ecologySectionList.clientHeight;
  let ecologySectionSlides = document.querySelectorAll('.ecology .section__slide');
  let ecologySectionQuestion = document.querySelector('.ecology .section__question');
  let ecologySectionMore = document.querySelector('.ecology .section__more')

  let socialSection = document.querySelector('.social');
  let socialSectionContainer = document.querySelector('.social .container');
  let socialSectionGradient = document.querySelector('.social .section__gradient');
  let socialSectionWidth = socialSection.clientWidth;
  let socialSectionLine = document.querySelector('.social .line');
  let socialSectionIcons = document.querySelectorAll('.social .section__icon');
  let socialSectionList = document.querySelector('.social .section__slides');
  let socialSectionListOffsetTop = socialSectionList.getBoundingClientRect().top;
  let socialySectionListHeight = socialSectionList.clientHeight;
  let socialSectionSlides = document.querySelectorAll('.social__slide');
  let socialSectionQuestion = document.querySelector('.social .section__question');
  let socialSectionMore = document.querySelector('.social .section__more')

  let managementSection = document.querySelector('.management');
  let managementSectionContainer = document.querySelector('.management .container');
  let managementSectionGradient = document.querySelector('.management .section__gradient');
  let managementSectionWidth = managementSection.clientWidth;
  let managementSectionLine = document.querySelector('.management .line');
  let managementSectionIcons = document.querySelectorAll('.management .section__icon');
  let managementSectionList = document.querySelector('.management .section__slides');
  let managementSectionListOffsetTop = managementSectionList.getBoundingClientRect().top;
  let managementSectionListHeight = managementSectionList.clientHeight;
  let managementSectionSlides = document.querySelectorAll('.management__slide');
  let managementSectionMore = document.querySelector('.management .section__more')

  let finishSection = document.querySelector('.finish');
  let finishSectionOffsetTop = finishSection.getBoundingClientRect().top;
  let finishSectionWidth = finishSection.clientWidth;
  let finishSectionHeight = finishSection.clientHeight;
  let finishLetters = document.querySelectorAll('.finish__letter');
  let finishLogo = document.querySelector('.finish__logo');
  let finishLine = document.querySelector('.finish__line');
  let finishLink = document.querySelector('.finish__link');

  let sectionSlidesTranslate = 250;
  let lineWidth = window.getComputedStyle(ecologySectionLine).getPropertyValue('width').replace(/[^0-9]/g,"");

  if (document.documentElement.clientWidth > 1023) {
    employeesSectionLine.addEventListener('click', () => {
      wrapper.scrollTo({
        top: 0,
        left: employeesSectionOffsetLeft,
        behavior: 'smooth'
      })
    })


    // Ecology
    ecologySection.animate(
      {
        right: ['calc(var(--width-line) * 3)', '100vw']
      },
      { duration: 10000, // Totally arbitrary!
        fill: 'both',
        timeline: new ScrollTimeline({
          source: wrapper,
          scrollSource: wrapper,
          orientation: 'horizontal',
          scrollOffsets: [
            CSS.px(employeesSectionOffsetLeft + employeesSectionWidth - windowWidth + 180),
            CSS.px(employeesSectionOffsetLeft + employeesSectionWidth - windowWidth + ecologySectionWidth),
          ],
        })
      }
    );

    ecologySectionGradient.animate(
      {
        opacity: ['0', '1']
      },
      { duration: 10000, // Totally arbitrary!
        fill: 'both',
        timeline: new ScrollTimeline({
          source: wrapper,
          scrollSource: wrapper,
          orientation: 'horizontal',
          scrollOffsets: [
            CSS.px(employeesSectionOffsetLeft + employeesSectionWidth - windowWidth + ecologySectionWidth + 300),
            CSS.px(employeesSectionOffsetLeft + employeesSectionWidth - windowWidth + ecologySectionWidth + 300 + sectionSlidesTranslate * 4),
          ],
        })
      }
    );

    ecologySectionLine.animate(
      {
        background: ['#FFFFFF', '#8024C0'],
        color: ['#8024C0', '#FFFFFF']
      },
      { duration: 10000, // Totally arbitrary!
        fill: 'both',
        timeline: new ScrollTimeline({
          source: wrapper,
          scrollSource: wrapper,
          orientation: 'horizontal',
          scrollOffsets: [
            CSS.px(employeesSectionOffsetLeft + employeesSectionWidth - windowWidth + ecologySectionWidth),
            CSS.px(employeesSectionOffsetLeft + employeesSectionWidth - windowWidth + ecologySectionWidth + 300),
          ],
        })
      }
    );

    ecologySectionLine.addEventListener('click', () => {
      wrapper.scrollTo({
        top: 0,
        left: employeesSectionOffsetLeft + employeesSectionWidth - windowWidth + ecologySectionWidth,
        behavior: 'smooth'
      })
    })

    ecologySectionIcons.forEach((icon, i) => {
      let iconSymbols = icon.querySelectorAll('.section__icon-symbol');
      let iconLogo = icon.querySelector('.section__icon-logo');

      if (i === 0) {
        iconSymbols.forEach(symbol => {
          symbol.animate(
            {
              transform: ['translateY(0)', 'translateY(-43px)']
            },
            { duration: 10000, // Totally arbitrary!
              fill: 'both',
              timeline: new ScrollTimeline({
                source: wrapper,
                scrollSource: wrapper,
                orientation: 'horizontal',
                scrollOffsets: [
                  CSS.px(employeesSectionOffsetLeft + employeesSectionWidth - windowWidth + ecologySectionWidth + 300 + sectionSlidesTranslate * 3),
                  CSS.px(employeesSectionOffsetLeft + employeesSectionWidth - windowWidth + ecologySectionWidth + 300 + sectionSlidesTranslate * 4),
                ],
              })
            }
          );
        })

        iconLogo.animate(
          {
            transform: ['translateY(0)', 'translateY(-43px)'],
            opacity: ['1', '0']
          },
          { duration: 10000, // Totally arbitrary!
            fill: 'both',
            timeline: new ScrollTimeline({
              source: wrapper,
              scrollSource: wrapper,
              orientation: 'horizontal',
              scrollOffsets: [
                CSS.px(employeesSectionOffsetLeft + employeesSectionWidth - windowWidth + ecologySectionWidth + 300 + sectionSlidesTranslate * 3),
                CSS.px(employeesSectionOffsetLeft + employeesSectionWidth - windowWidth + ecologySectionWidth + 300 + sectionSlidesTranslate * 4),
              ],
            })
          }
        );
      }

      if (i === 1) {
        iconSymbols.forEach(symbol => {
          symbol.animate(
            {
              transform: ['translateY(45px)', 'translateY(-130px)']
            },
            { duration: 10000, // Totally arbitrary!
              fill: 'both',
              timeline: new ScrollTimeline({
                source: wrapper,
                scrollSource: wrapper,
                orientation: 'horizontal',
                scrollOffsets: [
                  CSS.px(employeesSectionOffsetLeft + employeesSectionWidth - windowWidth + ecologySectionWidth + 300),
                  CSS.px(employeesSectionOffsetLeft + employeesSectionWidth - windowWidth + ecologySectionWidth + 300 + sectionSlidesTranslate * 4),
                ],
              })
            }
          );
        })
      }

      if (i === 2) {
        iconSymbols.forEach(symbol => {
          symbol.animate(
            {
              transform: ['translateY(44px)', 'translateY(-114px)']
            },
            { duration: 10000, // Totally arbitrary!
              fill: 'both',
              timeline: new ScrollTimeline({
                source: wrapper,
                scrollSource: wrapper,
                orientation: 'horizontal',
                scrollOffsets: [
                  CSS.px(employeesSectionOffsetLeft + employeesSectionWidth - windowWidth + ecologySectionWidth + 300),
                  CSS.px(employeesSectionOffsetLeft + employeesSectionWidth - windowWidth + ecologySectionWidth + 300 + sectionSlidesTranslate * 4),
                ],
              })
            }
          );
        })
      }
    })

    ecologySectionSlides.forEach(slide => {
      slide.animate(
        {
          transform: ['translateY(calc(100 * 1 * var(--vh, 1vh)))', 'translateY(calc(-100 * 3 * var(--vh, 1vh)))']
        },
        { duration: 10000, // Totally arbitrary!
          fill: 'both',
          timeline: new ScrollTimeline({
            source: wrapper,
            scrollSource: wrapper,
            orientation: 'horizontal',
            scrollOffsets: [
              CSS.px(employeesSectionOffsetLeft + employeesSectionWidth - windowWidth + ecologySectionWidth + 300),
              CSS.px(employeesSectionOffsetLeft + employeesSectionWidth - windowWidth + ecologySectionWidth + 300 + sectionSlidesTranslate * 4),
            ],
          })
        }
      );
    })

    ecologySectionQuestion.animate(
      {
        transform: ['translateY(calc(100 * 1 * var(--vh, 1vh)))', 'translateY(calc(-100 * 3 * var(--vh, 1vh)))']
      },
      { duration: 10000, // Totally arbitrary!
        fill: 'both',
        timeline: new ScrollTimeline({
          source: wrapper,
          scrollSource: wrapper,
          orientation: 'horizontal',
          scrollOffsets: [
            CSS.px(employeesSectionOffsetLeft + employeesSectionWidth - windowWidth + ecologySectionWidth + 300),
            CSS.px(employeesSectionOffsetLeft + employeesSectionWidth - windowWidth + ecologySectionWidth + 300 + sectionSlidesTranslate * 4),
          ],
        })
      }
    );

    let ecologySectionEnd = employeesSectionOffsetLeft + employeesSectionWidth - windowWidth + ecologySectionWidth + 300 + sectionSlidesTranslate * 4 + 500;

    ecologySectionContainer.animate(
      {
        transform: ['translateX(0)', 'translateX(-100vw)']
      },
      { duration: 10000, // Totally arbitrary!
        fill: 'both',
        timeline: new ScrollTimeline({
          source: wrapper,
          scrollSource: wrapper,
          orientation: 'horizontal',
          scrollOffsets: [
            CSS.px(ecologySectionEnd),
            CSS.px(ecologySectionEnd + socialSectionWidth),
          ],
        })
      }
    );

    // Social
    socialSection.animate(
      {
        right: ['calc(var(--width-line) * 2 + 1px)', '100vw']
      },
      { duration: 10000, // Totally arbitrary!
        fill: 'both',
        timeline: new ScrollTimeline({
          source: wrapper,
          scrollSource: wrapper,
          orientation: 'horizontal',
          scrollOffsets: [
            CSS.px(ecologySectionEnd),
            CSS.px(ecologySectionEnd + socialSectionWidth),
          ],
        })
      }
    );



    socialSectionGradient.animate(
      {
        opacity: ['0', '1']
      },
      { duration: 10000, // Totally arbitrary!
        fill: 'both',
        timeline: new ScrollTimeline({
          source: wrapper,
          scrollSource: wrapper,
          orientation: 'horizontal',
          scrollOffsets: [
            CSS.px(ecologySectionEnd + socialSectionWidth + 300),
            CSS.px(ecologySectionEnd + socialSectionWidth + 300 + sectionSlidesTranslate * 5),
          ],
        })
      }
    );

    socialSectionLine.animate(
      {
        background: ['#FFFFFF', '#FF3985'],
        color: ['#FF3985', '#FFFFFF']
      },
      { duration: 10000, // Totally arbitrary!
        fill: 'both',
        timeline: new ScrollTimeline({
          source: wrapper,
          scrollSource: wrapper,
          orientation: 'horizontal',
          scrollOffsets: [
            CSS.px(ecologySectionEnd + socialSectionWidth),
            CSS.px(ecologySectionEnd + socialSectionWidth + 300),
          ],
        })
      }
    );

    socialSectionLine.addEventListener('click', () => {
      wrapper.scrollTo({
        top: 0,
        left: ecologySectionEnd + socialSectionWidth,
        behavior: 'smooth'
      })
    })

    socialSectionIcons.forEach((icon, i) => {
      let iconSymbols = icon.querySelectorAll('.section__icon-symbol');
      let iconLogo = icon.querySelector('.section__icon-logo');

      if (i === 0) {
        iconSymbols.forEach(symbol => {
          symbol.animate(
            {
              transform: ['translateY(0)', 'translateY(-43px)']
            },
            { duration: 10000, // Totally arbitrary!
              fill: 'both',
              timeline: new ScrollTimeline({
                source: wrapper,
                scrollSource: wrapper,
                orientation: 'horizontal',
                scrollOffsets: [
                  CSS.px(ecologySectionEnd + socialSectionWidth + 300 + sectionSlidesTranslate * 4),
                  CSS.px(ecologySectionEnd + socialSectionWidth + 300 + sectionSlidesTranslate * 5),
                ],
              })
            }
          );
        })

        iconLogo.animate(
          {
            transform: ['translateY(0)', 'translateY(-43px)'],
            opacity: ['1', '0']
          },
          { duration: 10000, // Totally arbitrary!
            fill: 'both',
            timeline: new ScrollTimeline({
              source: wrapper,
              scrollSource: wrapper,
              orientation: 'horizontal',
              scrollOffsets: [
                CSS.px(ecologySectionEnd + socialSectionWidth + 300 + sectionSlidesTranslate * 4),
                CSS.px(ecologySectionEnd + socialSectionWidth + 300 + sectionSlidesTranslate * 5),
              ],
            })
          }
        );
      }

      if (i === 1) {
        iconSymbols.forEach(symbol => {
          symbol.animate(
            {
              transform: ['translateY(45px)', 'translateY(-170px)']
            },
            { duration: 10000, // Totally arbitrary!
              fill: 'both',
              timeline: new ScrollTimeline({
                source: wrapper,
                scrollSource: wrapper,
                orientation: 'horizontal',
                scrollOffsets: [
                  CSS.px(ecologySectionEnd + socialSectionWidth + 300),
                  CSS.px(ecologySectionEnd + socialSectionWidth + 300 + sectionSlidesTranslate * 5),
                ],
              })
            }
          );
        })
      }

      if (i === 2) {
        iconSymbols.forEach(symbol => {
          symbol.animate(
            {
              transform: ['translateY(38px)', 'translateY(-157px)']
            },
            { duration: 10000, // Totally arbitrary!
              fill: 'both',
              timeline: new ScrollTimeline({
                source: wrapper,
                scrollSource: wrapper,
                orientation: 'horizontal',
                scrollOffsets: [
                  CSS.px(ecologySectionEnd + socialSectionWidth + 300),
                  CSS.px(ecologySectionEnd + socialSectionWidth + 300 + sectionSlidesTranslate * 5),
                ],
              })
            }
          );
        })
      }
    })

    socialSectionSlides.forEach(slide => {
      slide.animate(
        {
          transform: ['translateY(calc(100 * 0 * var(--vh, 1vh)))', 'translateY(calc(-100 * 5 * var(--vh, 1vh)))']
        },
        { duration: 10000, // Totally arbitrary!
          fill: 'both',
          timeline: new ScrollTimeline({
            source: wrapper,
            scrollSource: wrapper,
            orientation: 'horizontal',
            scrollOffsets: [
              CSS.px(ecologySectionEnd + socialSectionWidth + 300),
              CSS.px(ecologySectionEnd + socialSectionWidth + 300 + sectionSlidesTranslate * 5),
            ],
          })
        }
      );
    })

    socialSectionQuestion.animate(
      {
        transform: ['translateY(calc(100 * 0 * var(--vh, 1vh)))', 'translateY(calc(-100 * 5 * var(--vh, 1vh)))']
      },
      { duration: 10000, // Totally arbitrary!
        fill: 'both',
        timeline: new ScrollTimeline({
          source: wrapper,
          scrollSource: wrapper,
          orientation: 'horizontal',
          scrollOffsets: [
            CSS.px(ecologySectionEnd + socialSectionWidth + 300),
            CSS.px(ecologySectionEnd + socialSectionWidth + 300 + sectionSlidesTranslate * 5),
          ],
        })
      }
    );

    let socialSectionEnd = ecologySectionEnd + socialSectionWidth + 300 + sectionSlidesTranslate * 5 + 500;

    socialSectionContainer.animate(
      {
        transform: ['translateX(0)', 'translateX(-100vw)']
      },
      { duration: 10000, // Totally arbitrary!
        fill: 'both',
        timeline: new ScrollTimeline({
          source: wrapper,
          scrollSource: wrapper,
          orientation: 'horizontal',
          scrollOffsets: [
            CSS.px(socialSectionEnd),
            CSS.px(socialSectionEnd + managementSectionWidth),
          ],
        })
      }
    );

    // Management
    managementSection.animate(
      {
        right: ['calc(var(--width-line) + 2px)', '100vw']
      },
      { duration: 10000, // Totally arbitrary!
        fill: 'both',
        timeline: new ScrollTimeline({
          source: wrapper,
          scrollSource: wrapper,
          orientation: 'horizontal',
          scrollOffsets: [
            CSS.px(socialSectionEnd),
            CSS.px(socialSectionEnd + managementSectionWidth),
          ],
        })
      }
    );

    managementSectionGradient.animate(
      {
        opacity: ['0', '1']
      },
      { duration: 10000, // Totally arbitrary!
        fill: 'both',
        timeline: new ScrollTimeline({
          source: wrapper,
          scrollSource: wrapper,
          orientation: 'horizontal',
          scrollOffsets: [
            CSS.px(socialSectionEnd + managementSectionWidth + 300),
            CSS.px(socialSectionEnd + managementSectionWidth + 300 + sectionSlidesTranslate * 2),
          ],
        })
      }
    );

    managementSectionLine.animate(
      {
        background: ['#FFFFFF', '#07F'],
        color: ['#07F', '#FFFFFF']
      },
      { duration: 10000, // Totally arbitrary!
        fill: 'both',
        timeline: new ScrollTimeline({
          source: wrapper,
          scrollSource: wrapper,
          orientation: 'horizontal',
          scrollOffsets: [
            CSS.px(socialSectionEnd + managementSectionWidth),
            CSS.px(socialSectionEnd + managementSectionWidth + 300),
          ],
        })
      }
    );

    managementSectionLine.addEventListener('click', () => {
      wrapper.scrollTo({
        top: 0,
        left: socialSectionEnd + managementSectionWidth,
        behavior: 'smooth'
      })
    })

    managementSectionIcons.forEach((icon, i) => {
      let iconSymbols = icon.querySelectorAll('.section__icon-symbol');
      let iconLogo = icon.querySelector('.section__icon-logo');

      // if (i === 0) {
      //   iconSymbols.forEach(symbol => {
      //     symbol.animate(
      //       {
      //         transform: ['translateY(0)', 'translateY(-43px)']
      //       },
      //       { duration: 10000, // Totally arbitrary!
      //         fill: 'both',
      //         timeline: new ScrollTimeline({
      //           source: wrapper,
      //           scrollSource: wrapper,
      //           orientation: 'horizontal',
      //           scrollOffsets: [
      //             CSS.px(socialSectionEnd + managementSectionWidth + 300 + sectionSlidesTranslate * 3),
      //             CSS.px(socialSectionEnd + managementSectionWidth + 300 + sectionSlidesTranslate * 4),
      //           ],
      //         })
      //       }
      //     );
      //   })

      //   iconLogo.animate(
      //     {
      //       transform: ['translateY(0)', 'translateY(-43px)']
      //     },
      //     { duration: 10000, // Totally arbitrary!
      //       fill: 'both',
      //       timeline: new ScrollTimeline({
      //         source: wrapper,
      //         scrollSource: wrapper,
      //         orientation: 'horizontal',
      //         scrollOffsets: [
      //           CSS.px(socialSectionEnd + managementSectionWidth + 300 + sectionSlidesTranslate * 3),
      //           CSS.px(socialSectionEnd + managementSectionWidth + 300 + sectionSlidesTranslate * 4),
      //         ],
      //       })
      //     }
      //   );
      // }

      if (i === 1) {
        iconSymbols.forEach(symbol => {
          symbol.animate(
            {
              transform: ['translateY(45px)', 'translateY(-45px)']
            },
            { duration: 10000, // Totally arbitrary!
              fill: 'both',
              timeline: new ScrollTimeline({
                source: wrapper,
                scrollSource: wrapper,
                orientation: 'horizontal',
                scrollOffsets: [
                  CSS.px(socialSectionEnd + managementSectionWidth + 300),
                  CSS.px(socialSectionEnd + managementSectionWidth + 300 + sectionSlidesTranslate * 2),
                ],
              })
            }
          );
        })
      }

      if (i === 2) {
        iconSymbols.forEach(symbol => {
          symbol.animate(
            {
              transform: ['translateY(44px)', 'translateY(-38px)']
            },
            { duration: 10000, // Totally arbitrary!
              fill: 'both',
              timeline: new ScrollTimeline({
                source: wrapper,
                scrollSource: wrapper,
                orientation: 'horizontal',
                scrollOffsets: [
                  CSS.px(socialSectionEnd + managementSectionWidth + 300),
                  CSS.px(socialSectionEnd + managementSectionWidth + 300 + sectionSlidesTranslate * 2),
                ],
              })
            }
          );
        })
      }
    })

    managementSectionSlides.forEach(slide => {
      slide.animate(
        {
          transform: ['translateY(calc(100 * 1 * var(--vh, 1vh)))', 'translateY(calc(-100 * 1 * var(--vh, 1vh)))']
        },
        { duration: 10000, // Totally arbitrary!
          fill: 'both',
          timeline: new ScrollTimeline({
            source: wrapper,
            scrollSource: wrapper,
            orientation: 'horizontal',
            scrollOffsets: [
              CSS.px(socialSectionEnd + managementSectionWidth + 300),
              CSS.px(socialSectionEnd + managementSectionWidth + 300 + sectionSlidesTranslate * 2),
            ],
          })
        }
      );
    })

    let managementSectionEnd = socialSectionEnd + managementSectionWidth + 300 + sectionSlidesTranslate * 2 + 500;

    managementSectionContainer.animate(
      {
        transform: ['translateX(0)', 'translateX(-100vw)']
      },
      { duration: 10000, // Totally arbitrary!
        fill: 'both',
        timeline: new ScrollTimeline({
          source: wrapper,
          scrollSource: wrapper,
          orientation: 'horizontal',
          scrollOffsets: [
            CSS.px(managementSectionEnd),
            CSS.px(managementSectionEnd + finishSectionWidth),
          ],
        })
      }
    );

    // Finish
    finishSection.animate(
      {
        right: ['0', '100vw']
      },
      { duration: 10000, // Totally arbitrary!
        fill: 'both',
        timeline: new ScrollTimeline({
          source: wrapper,
          scrollSource: wrapper,
          orientation: 'horizontal',
          scrollOffsets: [
            CSS.px(managementSectionEnd),
            CSS.px(managementSectionEnd + finishSectionWidth),
          ],
        })
      }
    );

    finishLetters.forEach((letter, i)  => {
      let translate;

      if (i === 0) translate = '20%'
      if (i === 1) translate = '50%'
      if (i === 2) translate = '80%'

      letter.animate(
        {
          left: [translate, '50%']
        },
        { duration: 10000, // Totally arbitrary!
          fill: 'both',
          timeline: new ScrollTimeline({
            source: wrapper,
            scrollSource: wrapper,
            orientation: 'horizontal',
            scrollOffsets: [
              CSS.px(managementSectionEnd + finishSectionWidth),
              CSS.px(managementSectionEnd + finishSectionWidth + sectionSlidesTranslate),
            ],
          })
        }
      );
    })

    finishLogo.animate(
      {
        left: ['-50%', '50%']
      },
      { duration: 10000, // Totally arbitrary!
        fill: 'both',
        timeline: new ScrollTimeline({
          source: wrapper,
          scrollSource: wrapper,
          orientation: 'horizontal',
          scrollOffsets: [
            CSS.px(managementSectionEnd + finishSectionWidth),
            CSS.px(managementSectionEnd + finishSectionWidth + sectionSlidesTranslate),
          ],
        })
      }
    );

    finishLink.animate(
      {
        opacity: ['0', '1']
      },
      { duration: 10000, // Totally arbitrary!
        fill: 'both',
        timeline: new ScrollTimeline({
          source: wrapper,
          scrollSource: wrapper,
          orientation: 'horizontal',
          scrollOffsets: [
            CSS.px(managementSectionEnd + finishSectionWidth + sectionSlidesTranslate),
            CSS.px(managementSectionEnd + finishSectionWidth + sectionSlidesTranslate + 100),
          ],
        })
      }
    );

    finishLine.animate(
      {
        transform: ['translateX(100%)', 'translateX(0)']
      },
      { duration: 10000, // Totally arbitrary!
        fill: 'both',
        timeline: new ScrollTimeline({
          source: wrapper,
          scrollSource: wrapper,
          orientation: 'horizontal',
          scrollOffsets: [
            CSS.px(managementSectionEnd + finishSectionWidth + sectionSlidesTranslate + 100),
            CSS.px(managementSectionEnd + finishSectionWidth + sectionSlidesTranslate + 200),
          ],
        })
      }
    );

    finishLine.addEventListener('click', () => {
      wrapper.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })

      setTimeout(() => {
        let welcomeSubtitleLink = document.querySelector('.welcome__subtitle-link');
        welcomeSubtitleLink.focus();
      }, 1500);
    })
  } else {
    // // Employees
    // let translate = (employeesSectionListItems.length - 1) * employeesSectionListItems[0].clientWidth;
    // employeesSectionMore.style.height = 2.5 * employeesSectionListItems[0].clientWidth + translate + 'px'

    // employeesSectionList.animate(
    //   {
    //     transform: [`translateX(0)`, `translateX(-${translate}px)`],
    //   },
    //   { duration: 10000, // Totally arbitrary!
    //     fill: 'both',
    //     timeline: new ScrollTimeline({
    //       source: document.scrollingElement,
    //       scrollSource: document.scrollingElement,
    //       orientation: 'block',
    //       scrollOffsets: [
    //         CSS.px(employeesSectionOffsetTop + employeesSectionWrapper.clientHeight),
    //         CSS.px(employeesSectionOffsetTop + employeesSectionWrapper.clientHeight + translate),
    //       ],
    //     })
    //   }
    // );
    
    // // Ecology
    // let translateEcology = (ecologySectionSlides.length + 0.3) * ecologySectionSlides[0].clientWidth;
    // ecologySectionMore.style.height = 4.5 * ecologySectionSlides[0].clientWidth + translateEcology + 'px'

    // ecologySectionList.animate(
    //   {
    //     transform: [`translateX(0)`, `translateX(-${translateEcology}px)`],
    //   },
    //   { duration: 10000, // Totally arbitrary!
    //     fill: 'both',
    //     timeline: new ScrollTimeline({
    //       source: document.scrollingElement,
    //       scrollSource: document.scrollingElement,
    //       orientation: 'block',
    //       scrollOffsets: [
    //         CSS.px(ecologySectionListOffsetTop + ecologySectionListHeight),
    //         CSS.px(ecologySectionListOffsetTop + ecologySectionListHeight + translateEcology),
    //       ],
    //     })
    //   }
    // );

    // ecologySectionIcons.forEach((icon, i) => {
    //   let iconSymbols = icon.querySelectorAll('.section__icon-symbol');
    //   let iconLogo = icon.querySelector('.section__icon-logo');

    //   if (i === 0) {
    //     iconSymbols.forEach(symbol => {
    //       symbol.animate(
    //         {
    //           transform: ['translateX(0)', 'translateX(-40px)']
    //         },
    //         { duration: 10000, // Totally arbitrary!
    //           fill: 'both',
    //           timeline: new ScrollTimeline({
    //             source: document.scrollingElement,
    //             scrollSource: document.scrollingElement,
    //             orientation: 'block',
    //             scrollOffsets: [
    //               CSS.px(ecologySectionListOffsetTop + ecologySectionListHeight + translateEcology * 0.75),
    //               CSS.px(ecologySectionListOffsetTop + ecologySectionListHeight + translateEcology),
    //             ],
    //           })
    //         }
    //       );
    //     })

    //     iconLogo.animate(
    //       {
    //         transform: ['translateX(0)', 'translateX(-40px)']
    //       },
    //       { duration: 10000, // Totally arbitrary!
    //         fill: 'both',
    //         timeline: new ScrollTimeline({
    //           source: document.scrollingElement,
    //           scrollSource: document.scrollingElement,
    //           orientation: 'block',
    //           scrollOffsets: [
    //             CSS.px(ecologySectionListOffsetTop + ecologySectionListHeight + translateEcology * 0.75),
    //             CSS.px(ecologySectionListOffsetTop + ecologySectionListHeight + translateEcology),
    //           ],
    //         })
    //       }
    //     );
    //   }

    //   if (i === 1) {
    //     iconSymbols.forEach(symbol => {
    //       symbol.animate(
    //         {
    //           transform: ['translateX(0)', 'translateX(-125px)']
    //         },
    //         { duration: 10000, // Totally arbitrary!
    //           fill: 'both',
    //           timeline: new ScrollTimeline({
    //             source: document.scrollingElement,
    //             scrollSource: document.scrollingElement,
    //             orientation: 'block',
    //             scrollOffsets: [
    //               CSS.px(ecologySectionListOffsetTop + ecologySectionListHeight),
    //               CSS.px(ecologySectionListOffsetTop + ecologySectionListHeight + translateEcology),
    //             ],
    //           })
    //         }
    //       );
    //     })
    //   }

    //   if (i === 2) {
    //     iconSymbols.forEach(symbol => {
    //       symbol.animate(
    //         {
    //           transform: ['translateX(0)', 'translateX(-120px)']
    //         },
    //         { duration: 10000, // Totally arbitrary!
    //           fill: 'both',
    //           timeline: new ScrollTimeline({
    //             source: document.scrollingElement,
    //             scrollSource: document.scrollingElement,
    //             orientation: 'block',
    //             scrollOffsets: [
    //               CSS.px(ecologySectionListOffsetTop + ecologySectionListHeight),
    //               CSS.px(ecologySectionListOffsetTop + ecologySectionListHeight + translateEcology),
    //             ],
    //           })
    //         }
    //       );
    //     })
    //   }
    // })

    // // Social
    // let translateSocial = (socialSectionSlides.length + 0.5) * socialSectionSlides[0].clientWidth;
    // socialSectionMore.style.height = 7 * socialSectionSlides[0].clientWidth + translateSocial + 'px'

    // socialSectionList.animate(
    //   {
    //     transform: [`translateX(0)`, `translateX(-${translateSocial}px)`],
    //   },
    //   { duration: 10000, // Totally arbitrary!
    //     fill: 'both',
    //     timeline: new ScrollTimeline({
    //       source: document.scrollingElement,
    //       scrollSource: document.scrollingElement,
    //       orientation: 'block',
    //       scrollOffsets: [
    //         CSS.px(socialSectionListOffsetTop + socialySectionListHeight),
    //         CSS.px(socialSectionListOffsetTop + socialySectionListHeight + translateSocial),
    //       ],
    //     })
    //   }
    // );

    // socialSectionIcons.forEach((icon, i) => {
    //   let iconSymbols = icon.querySelectorAll('.section__icon-symbol');
    //   let iconLogo = icon.querySelector('.section__icon-logo');

    //   if (i === 0) {
    //     iconSymbols.forEach(symbol => {
    //       symbol.animate(
    //         {
    //           transform: ['translateX(0)', 'translateX(-40px)']
    //         },
    //         { duration: 10000, // Totally arbitrary!
    //           fill: 'both',
    //           timeline: new ScrollTimeline({
    //             source: document.scrollingElement,
    //             scrollSource: document.scrollingElement,
    //             orientation: 'block',
    //             scrollOffsets: [
    //               CSS.px(socialSectionListOffsetTop + socialySectionListHeight + translateSocial * 0.8),
    //               CSS.px(socialSectionListOffsetTop + socialySectionListHeight + translateSocial),
    //             ],
    //           })
    //         }
    //       );
    //     })

    //     iconLogo.animate(
    //       {
    //         transform: ['translateX(0)', 'translateX(-40px)']
    //       },
    //       { duration: 10000, // Totally arbitrary!
    //         fill: 'both',
    //         timeline: new ScrollTimeline({
    //           source: document.scrollingElement,
    //           scrollSource: document.scrollingElement,
    //           orientation: 'block',
    //           scrollOffsets: [
    //             CSS.px(socialSectionListOffsetTop + socialySectionListHeight + translateSocial * 0.8),
    //             CSS.px(socialSectionListOffsetTop + socialySectionListHeight + translateSocial),
    //           ],
    //         })
    //       }
    //     );
    //   }

    //   if (i === 1) {
    //     iconSymbols.forEach(symbol => {
    //       symbol.animate(
    //         {
    //           transform: ['translateX(0)', 'translateX(-167px)']
    //         },
    //         { duration: 10000, // Totally arbitrary!
    //           fill: 'both',
    //           timeline: new ScrollTimeline({
    //             source: document.scrollingElement,
    //             scrollSource: document.scrollingElement,
    //             orientation: 'block',
    //             scrollOffsets: [
    //               CSS.px(socialSectionListOffsetTop + socialySectionListHeight),
    //               CSS.px(socialSectionListOffsetTop + socialySectionListHeight + translateSocial),
    //             ],
    //           })
    //         }
    //       );
    //     })
    //   }

    //   if (i === 2) {
    //     iconSymbols.forEach(symbol => {
    //       symbol.animate(
    //         {
    //           transform: ['translateX(0)', 'translateX(-160px)']
    //         },
    //         { duration: 10000, // Totally arbitrary!
    //           fill: 'both',
    //           timeline: new ScrollTimeline({
    //             source: document.scrollingElement,
    //             scrollSource: document.scrollingElement,
    //             orientation: 'block',
    //             scrollOffsets: [
    //               CSS.px(socialSectionListOffsetTop + socialySectionListHeight),
    //               CSS.px(socialSectionListOffsetTop + socialySectionListHeight + translateSocial),
    //             ],
    //           })
    //         }
    //       );
    //     })
    //   }
    // })

    // // Management
    // let translateManagement = (managementSectionSlides.length - 0.85) * managementSectionSlides[0].clientWidth;
    // managementSectionMore.style.height = 6 * managementSectionSlides[0].clientWidth + translateManagement + 'px'

    // managementSectionList.animate(
    //   {
    //     transform: [`translateX(0)`, `translateX(-${translateManagement}px)`],
    //   },
    //   { duration: 10000, // Totally arbitrary!
    //     fill: 'both',
    //     timeline: new ScrollTimeline({
    //       source: document.scrollingElement,
    //       scrollSource: document.scrollingElement,
    //       orientation: 'block',
    //       scrollOffsets: [
    //         CSS.px(managementSectionListOffsetTop + managementSectionListHeight),
    //         CSS.px(managementSectionListOffsetTop + managementSectionListHeight + translateManagement),
    //       ],
    //     })
    //   }
    // );

    // managementSectionIcons.forEach((icon, i) => {
    //   let iconSymbols = icon.querySelectorAll('.section__icon-symbol');
    //   let iconLogo = icon.querySelector('.section__icon-logo');

    //   if (i === 1) {
    //     iconSymbols.forEach(symbol => {
    //       symbol.animate(
    //         {
    //           transform: ['translateX(0)', 'translateX(-44px)']
    //         },
    //         { duration: 10000, // Totally arbitrary!
    //           fill: 'both',
    //           timeline: new ScrollTimeline({
    //             source: document.scrollingElement,
    //             scrollSource: document.scrollingElement,
    //             orientation: 'block',
    //             scrollOffsets: [
    //               CSS.px(managementSectionListOffsetTop + managementSectionListHeight),
    //               CSS.px(managementSectionListOffsetTop + managementSectionListHeight + translateManagement),
    //             ],
    //           })
    //         }
    //       );
    //     })
    //   }

    //   if (i === 2) {
    //     iconSymbols.forEach(symbol => {
    //       symbol.animate(
    //         {
    //           transform: ['translateX(0)', 'translateX(-40px)']
    //         },
    //         { duration: 10000, // Totally arbitrary!
    //           fill: 'both',
    //           timeline: new ScrollTimeline({
    //             source: document.scrollingElement,
    //             scrollSource: document.scrollingElement,
    //             orientation: 'block',
    //             scrollOffsets: [
    //               CSS.px(managementSectionListOffsetTop + managementSectionListHeight),
    //               CSS.px(managementSectionListOffsetTop + managementSectionListHeight + translateManagement),
    //             ],
    //           })
    //         }
    //       );
    //     })
    //   }
    // })

    // Finish
    finishLetters.forEach((letter, i)  => {
      let translate;

      if (i === 0) translate = '20%'
      if (i === 1) translate = '50%'
      if (i === 2) translate = '80%'

      letter.animate(
        {
          top: [translate, '50%']
        },
        { duration: 10000, // Totally arbitrary!
          fill: 'both',
          timeline: new ScrollTimeline({
            source: document.scrollingElement,
            scrollSource: document.scrollingElement,
            orientation: 'block',
            scrollOffsets: [
              CSS.px(finishSectionOffsetTop),
              CSS.px(finishSectionOffsetTop + sectionSlidesTranslate),
            ],
          })
        }
      );
    })

    finishLogo.animate(
      {
        left: ['-50%', '50%']
      },
      { duration: 10000, // Totally arbitrary!
        fill: 'both',
        timeline: new ScrollTimeline({
          source: document.scrollingElement,
          scrollSource: document.scrollingElement,
          orientation: 'block',
          scrollOffsets: [
            CSS.px(finishSectionOffsetTop),
            CSS.px(finishSectionOffsetTop + sectionSlidesTranslate),
          ],
        })
      }
    );

    finishLink.animate(
      {
        opacity: ['0', '1']
      },
      { duration: 10000, // Totally arbitrary!
        fill: 'both',
        timeline: new ScrollTimeline({
          source: document.scrollingElement,
          scrollSource: document.scrollingElement,
          orientation: 'block',
          scrollOffsets: [
            CSS.px(finishSectionOffsetTop + sectionSlidesTranslate),
            CSS.px(finishSectionOffsetTop + sectionSlidesTranslate + 100),
          ],
        })
      }
    );
  }
}

export { sectionsInit }